import { ChangeDetectionStrategy, Component, computed, input, Input } from '@angular/core';
import { CookiePreferences, CookieListenerDirective, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ContentBlock } from '../../models';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { Media, ResizePipe } from '@teamfoster/sdk/image';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ImageMapItem } from 'src/app/product-galleries/models/product-gallery.model';
import { MediaComponent } from 'src/app/core/components/media/media.component';
import { MediaPointMapComponent } from 'src/app/core/components/media-point-map/media-point-map.component';

@Component({
  selector: 'app-content-block-with-images',
  templateUrl: './content-block-with-images.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    CookieListenerDirective,
    RouterLink,
    SafePipe,
    ResizePipe,
    FromDictionaryPipe,
    StripEmbedPipe,
    NgOptimizedImage,
    MediaComponent,
    MediaPointMapComponent,
  ],
})
export class ContentBlockWithImagesComponent {
  block = input.required<ContentBlock>();
  cookies = input<CookiePreferences | undefined>();

  allMedia = computed(() => {
    const block = this.block();

    const imageMapUrls = new Set((block.imageMaps || []).map(m => m.media?.absoluteUrl).filter(Boolean));

    //  If maps have the same media as the gallery, they will be filtered out to avoid duplicates
    const filteredGallery = (block.gallery || []).filter(m => !imageMapUrls.has(m.absoluteUrl));

    const allMedia = [...(block.imageMaps || []), ...filteredGallery].filter(a => a);

    // Return first 3 items
    return allMedia.slice(0, 3);
  });

  getMediaItem(
    item:
      | Media
      | {
          id: string;
          media: Media | null;
          items: ImageMapItem[];
        }
  ) {
    if ('media' in item) {
      return item.media;
    }

    return item as Media;
  }

  getMediaPoints(item: { id: string; media: Media | null; items: ImageMapItem[] } | Media) {
    if ('items' in item) {
      return item.items;
    }

    return [];
  }
}
